import { render, staticRenderFns } from "./PropertyRentView.vue?vue&type=template&id=77a5a3aa&"
import script from "./PropertyRentView.vue?vue&type=script&lang=js&"
export * from "./PropertyRentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports